























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// import { Moment, isMoment } from "moment";
import moment = require('moment');

@Component({
  name: 'ui-days',
})
export default class UiDays extends Vue {
  @Prop({
    default: () => ['Пт', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
    type: Array,
  })
  weekday: any[];

  @Prop({ default: new Date(), type: Date }) date: Date;
  @Prop({ default: new Date(), type: Date }) dateSecond: Date;
  @Prop({ type: Function }) allowedToShowView: Function;
  @Prop({ default: null, type: Date }) minimumDate: Date;
  @Prop({ default: null, type: Date }) maximumDate: Date;
  @Prop({ default: false, type: Boolean }) isDateRange: boolean;
  @Prop({ default: () => [] }) eventDates: Array<any>;
  @Prop({ default: true, type: Boolean }) showCurrentDay: boolean;
  @Prop({ default: true, type: Boolean }) letSelectAllDays: boolean;

  innerDays: any[] = [];
  innerMonth = this.date.getMonth();
  innerYear = this.date.getFullYear();
  innerDay = this.date.getDate();
  innerDate = this.date; // первая дата
  innerSecondDate = this.dateSecond; // вторая дата
  weeks: any[] = [];
  // days = this.innerDays;
  click = false;
  mounted() {
    this.installWeeks();
    this.setMonth(this.date);
  }
  @Watch('date')
  onChangeInnerDate() {
    if (this.isDateRange) {
      if (!this.click) {
        this.innerSecondDate = this.innerDate;
        this.click = !this.click;
      } else {
        if (this.innerDate > this.innerSecondDate) {
          var k = this.innerDate;
          this.innerDate = this.innerSecondDate;
          this.innerSecondDate = k;
        }
        this.click = !this.click;
      }
      this.clearDaysAll();
      //this.innerDate = this.date;
      this.setMonth(this.date);
    }
  }
  // @Watch("dateSecond")
  // onChangeInnerSecondDate() {
  //   if (this.date > this.dateSecond) {
  //     this.innerDate = this.innerSecondDate;
  //   }
  //   this.clearDaysAll();
  //   this.innerSecondDate = this.dateSecond;
  //   this.setMonth(this.dateSecond);
  // }
  days() {
    return this.innerDays;
  }

  /**
   * Устанавливаем текущий месяц, собираем массив дней, дополняя его до 6 недель
   */
  setMonth(date: Date) {
    // debugger
    this.innerMonth = date.getMonth();
    this.innerYear = date.getFullYear();
    this.innerDays = [];
    var firstDay = new Date(this.innerYear, this.innerMonth, 1).getDay() || 7;
    var days = new Date(this.innerYear, this.innerMonth + 1, 0).getDate();
    var lastDay = new Date(this.innerYear, this.innerMonth, days).getDay() || 7;
    let begin = 2 - firstDay;
    var end = days + (7 - lastDay);
    end = end - begin < 41 ? end + 7 : end;
    for (let index = begin; index <= end; index++) {
      this.innerDays.push({
        type: this.getStyle(index, days),
        number: new Date(this.innerYear, this.innerMonth, index).getDate(),
      });
    }
  }
  ////
  getStyle(index: number, days: any) {
    // return index < 1 || index > days || !this.checkDateActivity(index)
    //   ? "no-active"
    //   : moment(new Date(this.innerYear, this.innerMonth, index)).isSame(
    //       this.innerDate
    //     ) && !this.isDateRange
    //   ? "current"
    //   : moment(new Date(this.innerYear, this.innerMonth, index)).isBetween(
    //       this.innerDate,
    //       this.innerSecondDate,
    //       null,
    //       "()"
    //     )
    //   ? "current-area"
    //   : moment(new Date(this.innerYear, this.innerMonth, index)).isSame(
    //       this.innerSecondDate
    //     )
    //   ? "current-area-end"
    //   : moment(new Date(this.innerYear, this.innerMonth, index)).isSame(
    //       this.innerDate
    //     )
    //   ? "current-area-begin"
    //   : this.eventDates.findIndex(item =>
    //       moment(item.date).isSame(
    //         new Date(this.innerYear, this.innerMonth, index)
    //       )
    //     ) != -1
    //   ? "event-day"
    //   : "";
    var result = '';

    if (index < 1 || index > days || !this.checkDateActivity(index)) {
      result = 'no-active';
    }
    // console.log("ddd",moment(new Date(this.innerYear, this.innerMonth, index)).isSame(this.innerDate,'day'),"----",this.innerDate)
    if (moment(new Date(this.innerYear, this.innerMonth, index)).isSame(this.innerDate, 'day') && !this.isDateRange) {
      result = result + ' current ';
    }

    if (this.isDateRange) {
      if (moment(new Date(this.innerYear, this.innerMonth, index)).isBetween(this.innerDate, this.innerSecondDate, null, '()')) result = 'current-area';

      if (moment(new Date(this.innerYear, this.innerMonth, index)).isSame(this.innerSecondDate, 'day')) result = 'current-area-end';

      if (moment(new Date(this.innerYear, this.innerMonth, index)).isSame(this.innerDate, 'day')) result = 'current-area-begin';
    }

    var eventDateIndex = this.eventDates.length > 0 ? this.eventDates.findIndex((item) => moment(item).isSame(new Date(this.innerYear, this.innerMonth, index))) : -1;

    if (moment(new Date(this.innerYear, this.innerMonth, index)).isSame(this.innerDate, 'day') && moment(new Date(this.innerYear, this.innerMonth, index)).isSame(this.innerSecondDate, 'day'))
      result = 'current-area-begin-single';

    if (eventDateIndex != -1) {
      // if (moment(new Date(this.innerYear, this.innerMonth, index)).isBetween(this.innerDate, this.innerSecondDate, null, "()"))
      //     result = "event-day--" + "red";
      // else {
      result = result + 'event-day-' + 'green';
      // }
    }
    return result;
  }

  /**
   * Проверить активность даты
   */
  checkDateActivity(day: any) {
    if (!this.minimumDate) return true;
    var x = new Date(this.innerYear, this.innerMonth, day) > this.minimumDate;
    return x;
  }
  next() {
    this.setMonth(new Date(this.innerYear, this.innerMonth + 1, 1));
  }
  backward() {
    this.setMonth(new Date(this.innerYear, this.innerMonth - 1, 1));
  }
  changeMonth() {
    this.$emit('onNavigation');
  }
  changeDay(day: any) {
    let mon = parseInt(moment(this.date).format('MM')) - 1;

    let hour = parseInt(moment(this.date).format('HH'));
    let min = parseInt(moment(this.date).format('mm'));
    let sek = parseInt(moment(this.date).format('ss'));

    if (day.type != 'no-active') {
      this.clearDays();
      this.innerDay = day.number;
      day.type = 'current';
      this.innerDate = new Date(this.innerYear, this.innerMonth, this.innerDay, hour, min, sek);
      this.$emit('changeDay', new Date(this.innerYear, this.innerMonth, day.number, hour, min, sek));
    }
  }

  clearDays() {
    for (let index = 0; index < this.innerDays.length; index++) {
      if (this.innerDays[index].type == 'current') {
        this.innerDays[index].type = '';
      }
    }
  }
  clearDaysAll() {
    for (let index = 0; index < this.innerDays.length; index++) {
      this.innerDays[index].type = '';
    }
  }
  openHours() {
    this.$emit('changeCurrentView', 'hours');
  }
  installWeeks() {
    var moment = require('moment');
    var startOfWeek = moment().startOf('isoWeek');
    var endOfWeek = moment().endOf('isoWeek');

    this.weeks = [];
    var day = startOfWeek;

    while (day <= endOfWeek) {
      this.weeks.push(day.toDate());
      day = day.clone().add(1, 'd');
    }
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-date-picker/src/ui-days.vue